import { FC } from 'react';
import { ViewMode } from '@/utils/activity-calendar/enums/ActivityCalendar.enum';
import { ICalendarFarm as CalendarFarm } from '@/utils/activity-calendar/interfaces/ICalendarFarm';
import { ALL_FARMS_FILTER } from '@/utils/activity-calendar/constants';

interface IProps {
  subtitle: string;
  farm: string;
  farms: CalendarFarm[];
  onFarmChange: (farm: string) => void;
  view: ViewMode;
  onViewChange: (view: ViewMode) => void;
}

const VIEWS: { key: ViewMode; label: string }[] = [
  { key: ViewMode.Week, label: 'Week' },
  { key: ViewMode.Month, label: 'Month' },
  { key: ViewMode.Year, label: 'Year' },
];

export const CalendarHeader: FC<IProps> = ({ subtitle, farm, farms, onFarmChange, view, onViewChange }) => (
  <div className="flex flex-wrap items-center justify-between gap-[16px] border-b px-[18px] py-[16px]" style={{ borderColor: '#E5E7EB' }}>
    <div className="flex items-center gap-[12px]">
      <span className="flex h-[40px] w-[40px] flex-[0_0_auto] items-center justify-center rounded-[10px] bg-secondary text-primary">
        <svg width="20" height="20" viewBox="0 0 16 16" fill="currentColor">
          <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
        </svg>
      </span>
      <div>
        <h3 className="m-0 font-display text-[18px] font-extrabold text-[#1F2937]">Activity Calendar</h3>
        <div className="mt-[2px] text-[12px] text-[#6B7280]">{subtitle}</div>
      </div>
    </div>

    <div className="flex flex-wrap items-center gap-[14px]">
      <div className="flex items-center gap-[8px]">
        <span className="text-[12px] font-bold uppercase tracking-[0.08em] text-[#6B7280]">Farm</span>
        <div className="relative inline-flex">
          <select
            value={farm}
            onChange={(e) => onFarmChange(e.target.value)}
            className="h-[40px] min-w-[190px] cursor-pointer appearance-none rounded-[12px] border bg-[#F7F8F5] py-0 pl-[14px] pr-[36px] font-sans text-[14px] font-semibold text-[#0f172a] outline-none"
            style={{ borderColor: '#D6DED6' }}
          >
            <option value={ALL_FARMS_FILTER}>All farms</option>
            {farms.map((f) => (
              <option key={f.farmId} value={f.farmName}>
                {f.farmName}
              </option>
            ))}
          </select>
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#6B7280"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="pointer-events-none absolute right-[12px] top-1/2 -translate-y-1/2"
          >
            <path d="M6 9l6 6 6-6" />
          </svg>
        </div>
      </div>

      <div className="inline-flex rounded-[12px] border bg-[#F7F8F5] p-[3px]" style={{ borderColor: '#D6DED6' }}>
        {VIEWS.map((viewOption) => {
          const active = view === viewOption.key;
          return (
            <button
              key={viewOption.key}
              type="button"
              onClick={() => onViewChange(viewOption.key)}
              className="h-[34px] rounded-[9px] border-none px-[16px] font-sans text-[13px] font-bold"
              style={{
                cursor: 'pointer',
                background: active ? '#fff' : 'transparent',
                color: active ? '#2D855F' : '#6B7280',
                boxShadow: active ? '0 2px 6px rgb(15 23 42 / 0.08)' : 'none',
              }}
            >
              {viewOption.label}
            </button>
          );
        })}
      </div>
    </div>
  </div>
);
